import { render, staticRenderFns } from "./ResetPasswordModal.vue?vue&type=template&id=193932ba&scoped=true"
import script from "./ResetPasswordModal.vue?vue&type=script&lang=js"
export * from "./ResetPasswordModal.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordModal.vue?vue&type=style&index=0&id=193932ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193932ba",
  null
  
)

export default component.exports